/** Build reverse map; throws if two keys share the same slug. */
function invertStepSlugMap(map: Record<string, string>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [stepKey, slug] of Object.entries(map)) {
    if (out[slug]) {
      throw new Error(`Duplicate slug "${slug}" for step keys "${out[slug]}" and "${stepKey}"`);
    }
    out[slug] = stepKey;
  }
  return out;
}

/** Send cash flow — aligned with MainSendCashScreen step keys */
export const SEND_STEP_KEY_TO_SLUG: Record<string, string> = {
  phone: "phone-number",
  country: "country",
  state: "state",
  sendingAmountEntry: "sending-amount",
  howTheyReceive: "how-they-receive",
  reviewAndEditStep: "review-and-edit",
  senderName: "sender-name",
  senderAddress: "sender-address",
  senderDOB: "sender-dob",
  senderIdentification: "sender-identification",
  stateOfId: "state-of-id",
  senderIdNumber: "sender-id-number",
  receiverName: "receiver-name",
  additionalInformation: "additional-information",
  fraudPrevention: "fraud-prevention",
  finalReview: "final-review",
  pin: "pin",
  confirmPin: "confirm-pin",
  pinCreated: "pin-created",
  headToCashier: "head-to-cashier",
  otp: "otp",
};

export const SEND_SLUG_TO_STEP_KEY = invertStepSlugMap(SEND_STEP_KEY_TO_SLUG);

export function sendStepKeyToSlug(key: string): string | undefined {
  return SEND_STEP_KEY_TO_SLUG[key];
}

export function sendSlugToStepKey(slug: string): string | undefined {
  return SEND_SLUG_TO_STEP_KEY[slug];
}

export const SEND_DEFAULT_SLUG = SEND_STEP_KEY_TO_SLUG.phone;

/** Receive flow — MainReceiveScreen */
export const RECEIVE_STEP_KEY_TO_SLUG: Record<string, string> = {
  receiverReferenceNumber: "reference-number",
  receiveAmount: "receive-amount",
  tellUsAboutYouself: "tell-us-about-yourself",
  receiverPhone: "receiver-phone",
  receiverIdentificationType: "receiver-identification-type",
  receiverIdNumber: "receiver-id-number",
  receiverstateOfId: "receiver-state-of-id",
  receiverAddress: "receiver-address",
  receiverDOB: "receiver-dob",
  additionalReceiverInformation: "additional-information",
  receiverHeadToCashier: "head-to-cashier",
};

export const RECEIVE_SLUG_TO_STEP_KEY = invertStepSlugMap(RECEIVE_STEP_KEY_TO_SLUG);

export function receiveStepKeyToSlug(key: string): string | undefined {
  return RECEIVE_STEP_KEY_TO_SLUG[key];
}

export function receiveSlugToStepKey(slug: string): string | undefined {
  return RECEIVE_SLUG_TO_STEP_KEY[slug];
}

export const RECEIVE_DEFAULT_SLUG = RECEIVE_STEP_KEY_TO_SLUG.receiverReferenceNumber;

/** Bill pay — union of keys from EXISTING + NEW consumer flows (MainBillPayScreen) */
export const BILL_PAY_STEP_KEY_TO_SLUG: Record<string, string> = {
  phone: "phone-number",
  pin: "pin",
  previosBillerInfo: "previous-biller-info",
  accountInformation: "account-information",
  payAmount: "pay-amount",
  reviewAndEdit: "review-and-edit",
  billPayDOB: "date-of-birth",
  additionalInformation: "additional-information",
  fraudPrevention: "fraud-prevention",
  billPayFinalReview: "final-review",
  billPayHeadToCashier: "head-to-cashier",
  billPayAddress: "address",
  billPayFullName: "full-name",
  confirmPin: "confirm-pin",
  pinCreated: "pin-created",
};

export const BILL_PAY_SLUG_TO_STEP_KEY = invertStepSlugMap(BILL_PAY_STEP_KEY_TO_SLUG);

export function billPayStepKeyToSlug(key: string): string | undefined {
  return BILL_PAY_STEP_KEY_TO_SLUG[key];
}

export function billPaySlugToStepKey(slug: string): string | undefined {
  return BILL_PAY_SLUG_TO_STEP_KEY[slug];
}

export const BILL_PAY_DEFAULT_SLUG = BILL_PAY_STEP_KEY_TO_SLUG.phone;
